module.exports = __webpack_public_path__ + "static/media/SF-Pro-Display-Light.d8b75209.otf";